import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dimmer,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const Blocker = props => (
  <Dimmer.Dimmable as={Segment} style={{ padding: 0 }} blurring dimmed={true}>
    <Dimmer inverted true={true}>
      <Header size="huge" icon>
        <Icon name="lock" />Private Beta
      </Header>
      <Container>
        <Button
          className="gradient"
          primary
          size="huge"
          style={{ position: 'relative' }}
          as={Link}
          to="/signup"
        >
          Get Early Access
        </Button>
      </Container>
    </Dimmer>
    {props.children}
  </Dimmer.Dimmable>
);

Blocker.propTypes = {
  results: PropTypes.object.isRequired,
};

export default Blocker;



// WEBPACK FOOTER //
// ./src/containers/Markets/components/Blocker/index.jsx